// Clasificación de categorías para los estados financieros (#110).
// Misma lista que backend/src/utils/clasesResultado.js: si se cambia una,
// se cambia la otra (y el ENUM de categorias.clase_resultado).
// `label` depende del tipo de la categoría porque una misma clase se lee
// distinto en un ingreso y en un egreso (ej. préstamo recibido / pago de
// préstamo).

export const CLASES_RESULTADO = [
  { value: 'ingreso_operativo', grupo: 'Estado de resultados', label: { ingreso: 'Ingreso operativo (ventas)' } },
  { value: 'otro_ingreso', grupo: 'Estado de resultados', label: { ingreso: 'Otro ingreso' } },
  { value: 'costo', grupo: 'Estado de resultados', label: { egreso: 'Costo de ventas' } },
  { value: 'gasto', grupo: 'Estado de resultados', label: { egreso: 'Gasto operativo' } },
  { value: 'otro_gasto', grupo: 'Estado de resultados', label: { egreso: 'Otro gasto (financiero, impuestos)' } },
  { value: 'prestamo_recibido', grupo: 'Balance', label: { ingreso: 'Préstamo recibido', egreso: 'Pago de préstamo recibido' } },
  { value: 'prestamo_otorgado', grupo: 'Balance', label: { ingreso: 'Cobro de préstamo otorgado', egreso: 'Préstamo otorgado' } },
  { value: 'activo_fijo', grupo: 'Balance', label: { ingreso: 'Venta de activo fijo', egreso: 'Compra de activo fijo' } },
  { value: 'socios', grupo: 'Balance', label: { ingreso: 'Aporte de socios', egreso: 'Retiro de socios' } },
  { value: 'neutro', grupo: 'No afecta', label: { ingreso: 'Neutro (cambio de divisas, ajustes)', egreso: 'Neutro (cambio de divisas, ajustes)' } }
];

export function clasesParaTipo(tipo) {
  return CLASES_RESULTADO.filter((c) => c.label[tipo]);
}

export function etiquetaClase(value, tipo) {
  const c = CLASES_RESULTADO.find((x) => x.value === value);
  return c ? c.label[tipo] || '' : '';
}
